export default __webpack_public_path__ + "static/media/lp5.9059da46.jpg";